// Salesperson API

import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { SALESPERSONS } = API_ENDPOINTS;

export const salespersonApi = {
  /** GET /admin/salesperson/list/ — params: { search, is_active, include_deleted } */
  getList: (params = {}) => axiosInstance.get(SALESPERSONS.LIST, { params }),

  /** GET /admin/salesperson/<id>/ */
  getDetail: (id) => axiosInstance.get(SALESPERSONS.DETAIL(id)),

  /** POST /admin/salesperson/create/ */
  create: (data) => axiosInstance.post(SALESPERSONS.CREATE, data),

  /** PATCH /admin/salesperson/update/<id>/ */
  update: (id, data) => axiosInstance.patch(SALESPERSONS.UPDATE(id), data),

  /** DELETE /admin/salesperson/delete/<id>/ — requires admin password in body */
  remove: (id, password) =>
    axiosInstance.delete(SALESPERSONS.DELETE(id), { data: { password } }),

  /** PATCH /admin/salesperson/<id>/active/ */
  toggleActive: (id, is_active) =>
    axiosInstance.patch(SALESPERSONS.TOGGLE_ACTIVE(id), { is_active }),

  /** POST /admin/salesperson/<id>/restore/ */
  restore: (id) => axiosInstance.post(SALESPERSONS.RESTORE(id)),

  /** GET /admin/salesperson/<id>/analytics/?period=month
   *  extra: { daily_from, daily_to } — YYYY-MM-DD window for the Daily
   *  Activity table (defaults to the backend's last-30-days). */
  getAnalytics: (id, period = 'month', extra = {}) =>
    axiosInstance.get(SALESPERSONS.ANALYTICS(id), { params: { period, ...extra } }),
};
